import React from 'react';
import { Select } from '@/shared/components/ui/Select';
import { Icon } from '@/shared/icons';

interface DatabaseOption { id: string; name: string }

interface PanelDatabasesProps {
  databaseIds: string[];
  databases: DatabaseOption[];
  onAdd: (id: string) => void;
  onRemove: (id: string) => void;
}

/** Bancos de dados vinculados ao website (consumidos pelos blocos de listagem). */
export const PanelDatabases: React.FC<PanelDatabasesProps> = ({ databaseIds, databases, onAdd, onRemove }) => {
  const available = databases.filter((d) => !databaseIds.includes(d.id));

  return (
    <div className="space-y-3">
      {databaseIds.map((dbId) => {
        const db = databases.find((d) => d.id === dbId);
        return (
          <div
            key={dbId}
            className="flex items-center justify-between px-3 py-2 rounded-lg border"
            style={{ borderColor: 'var(--theme-card-border)', backgroundColor: 'var(--theme-card-background)' }}
            data-testid={`database-item-${dbId}`}
          >
            <div className="flex items-center gap-2 min-w-0">
              <Icon name="database" className="w-4 h-4 flex-shrink-0" style={{ color: 'var(--theme-primary)' }} />
              <span className="text-sm truncate" style={{ color: 'var(--theme-card-text)' }}>{db?.name || dbId}</span>
            </div>
            <button
              type="button"
              onClick={() => onRemove(dbId)}
              className="p-1 rounded-md hover:opacity-70 transition-opacity"
              style={{ color: 'var(--theme-muted-text)' }}
              title="Remover banco de dados"
              data-testid={`database-remove-${dbId}`}
            >
              <Icon name="x" className="w-3.5 h-3.5" />
            </button>
          </div>
        );
      })}

      {available.length > 0 && (
        <Select
          value=""
          onChange={(val) => { if (val) onAdd(val); }}
          options={available.map((d) => ({ label: d.name, value: d.id }))}
          placeholder="Adicionar banco de dados..."
          data-testid="database-add-select"
        />
      )}

      {databases.length === 0 && (
        <p className="text-sm" style={{ color: 'var(--theme-muted-text)' }}>
          Nenhum banco de dados disponível. Crie um banco de dados primeiro.
        </p>
      )}
    </div>
  );
};
